document.addEventListener('alpine:init', () => {
    /** example for event structure:
     * event: {
            eventHandler: 'lightswitchChanged',
            on: 'change',
            options: {},
        },
     */
    window.Alpine.magic('lightswitchChanged', () => event => {
        let options = typeof event.detail.options === 'string' ? JSON.parse(event.detail.options) : event.detail.options;
        window.dispatchEvent(new CustomEvent('lightswitch-changed', {
            detail: {
                value: event.detail.value,
            }
        }));
        event.target.checked = event.detail.value === 'checked';
    });

});
